var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClutchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.4,
    cy: 12,
    r: 4.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.07,18.56c-4.83-0.58-7.5-4.72-6.9-7.42c1.19-5.36,7.32-7.79,11.43-4.36c0.36,0.3,1.06,0.81,1.26,0.56 l2.13-2.08c0.29-0.29,0.28-0.76-0.03-1.03c-8.74-7.6-18.94-0.75-18.94,7.35c0,11.42,13.55,14.63,19.15,8.24 c0.01-0.01,0.01-0.02,0.01-0.03c0.12-0.3,0.05-0.64-0.17-0.88l-1.59-1.8c-0.32-0.37-1.32,0.38-1.76,0.59 C15.55,18.68,13.32,18.59,13.07,18.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutchIcon);
export default __webpack_public_path__ + "static/media/clutchIcon.ee0d50e740791118d3cce85838693901.svg";
export { ForwardRef as ReactComponent };